import { getKeys } from './getKeys'

export const riskAssessmentsTranslations = {
  NOTHING_TO_SEE_HERE: 'Nothing to see here!',
  NO_HISTORICAL_ASSESSMENTS:
    'Older versions of this risk assessment will appear here after you have performed reviews.',
  NO_LINKED_ASSESSMENTS: `Risk assessments will appear here if they are no longer attached to any of {{name}}'s {{carePlanNominative}}.`,
  FIND_OUT_MORE: 'Find out more',
  SORT_BY: 'Sort by:',
  CURRENT: 'Current',
  HISTORY: 'History',
  NOT_ATTACHED_TO_CARE_PLAN: 'Not attached to any {{carePlanNominative}}',
  NO_CURRENT_RISK_ASSESSMENTS: 'No current risk assessments found.',
  ARCHIVED_RISK_ASSESSMENTS: 'Archived Risk Assessments',
  NO_ARCHIVED_RISK_ASSESSMENTS: 'No archived risk assessments found.',
  EDIT: 'Edit',
  RESTORE_RISK_ASSESSMENT: 'Restore Risk Assessment',
  ARCHIVE_RISK_ASSESSMENT: 'Archive Risk Assessment',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  CONFIRM: 'Confirm',
  ARCHIVE_RISK_ASSESSMENT_TITLE: 'Archive Risk Assessment',
  ARCHIVE_REASON_DESCRIPTION:
    'Please provide a reason for archiving this Risk. This will be added to the Assessment for audit purposes.',
  ARCHIVE_NOTE:
    'Note: This assessment will be detached from any connected care plans',
  REASON_FOR_ARCHIVING: 'Reason for archiving',
  TYPE_HERE_PLACEHOLDER: 'Type here...',
  BACK: 'Back',
  ARCHIVED_BY: 'This was archived by {{carerName}} on: ',
  REASON: 'Reason: ',
  SIMILAR_ASSESSMENTS_TITLE:
    'There are existing Risk Assessments of a similar name',
  SIMILAR_ASSESSMENTS_SUBTITLE:
    'To avoid creating conflicting Risk Assessments we suggest using a templated Risk where possible, if the templates dont cover your needs, feel free to continue with the Custom Risk Assessment',
}

export const riskAssessmentsConstants = getKeys(riskAssessmentsTranslations)
